import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Drawer = ({ open, onClose, side = "right", label, children, testId }) => {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.__lenis?.stop?.();
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.__lenis?.start?.();
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  const x = side === "right" ? "100%" : "-100%";
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.button
            aria-label="Close"
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-[60] bg-[#0F2A12]/45 backdrop-blur-[2px]"
            data-testid={`${testId}-overlay`}
          />
          <motion.aside
            role="dialog"
            aria-modal="true"
            aria-label={label}
            initial={{ x }}
            animate={{ x: 0 }}
            exit={{ x }}
            transition={{ duration: 0.34, ease }}
            className={`fixed top-0 bottom-0 ${side === "right" ? "right-0" : "left-0"} z-[70] w-[86vw] max-w-[400px] bg-[#FFF8E7] shadow-[0_0_80px_-20px_rgba(0,0,0,0.5)] flex flex-col`}
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
            data-testid={testId}
          >
            {children}
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
};
